
<app-create-app *ngIf="AppService.isApp" [domain]="domain" (reloadapps)="get()"></app-create-app>

<app-spinner *ngIf="load_delete" [loading]="load_delete" [fullScreen]="true" [text]="'Deleting in progress, please wait'"></app-spinner>

<app-spinner *ngIf="load_check" [loading]="load_check" [fullScreen]="true" [text]="'ვამოწმებთ დომენს'"></app-spinner>


<app-error *ngIf="error" [title]="''"></app-error>


<div class="container cont mt-5">

    <div class="input-group  bg-light p-2 sm-p-2 rounded">
        <input
            type="text"
            [(ngModel)]="domain"
            placeholder="{{ 'DOMAIN_NAME' | translate }}"
            class="form-control border-0 bg-none form-control-lg input-domain"
            [ngModelOptions]="{ standalone: true }"
            (input)="onDomainInput($event)"
            [ngClass]="{
                'is-invalid': domain && (!isDomainValid || isDomainTaken)
            }"
        >
        <span class="input-group-text bg-none border-0 h-input">
            <span class="domain-name" [ngClass]="{'active-domain-name': domain}">.menuload.com</span>
            <button
            class="mx-3 create-btn btn"
            (click)="openPayModal({'create': true, 'sub_domain': domain})"
            [disabled]="!domain || !isDomainValid"
            >
            <i class="fi fi-rr-plus"></i>
            </button>
        </span>
       
    </div>
     <!-- Error Message -->
        <div *ngIf="domain && !isDomainValid" class="text-danger small">
            დაშვებულია მხოლოდ ლათინური ასოები, რიცხვები და დეში
        </div>
        <div *ngIf="isDomainTaken" class="text-danger small">
            დომენი დაკავებულია
        </div>
        
        <div class="row d-flex justify-content-center mt-4" *ngIf="load">
            <app-spinner *ngIf="load" [loading]="load"></app-spinner>
        </div>

    <div class="row d-flex justify-content-center mt-4" *ngIf="!load">
         
        <div class="col-12 mb-4 "  *ngFor="let item of data">


            <div class="card border-0 p-0 rounded position-relavite" > 
                
                <!-- <div class="package-info text-success position-absolute">
                    pro
                </div> -->
                <div class="d-flex justify-content-center align-items-center pey-info position-absolute rounded" *ngIf="item.payment_status === 'unpaid'">
                        <button type="button"  class="btn btn-danger" (click)="openPayModal(item)">
                            ვადის გაგრძელება
                        </button>
                    </div>

                <div class="card-body position-relavite">
       
                    <div class="d-flex flex-column ">
                        <div class="btn text-center bg-white border-0 rounded d-flex justify-content-between">
                            <div class="d-flex align-items-center"><i class="fi fi-rr-qrcode" (click)="openQrModal(item)"></i></div>
                            <div class="d-flex flex-column mx-3">
                                <a href="https://{{item.sub_domain }}.menuload.com" class="link" target="_blank">{{ item.sub_domain }}.menuload.com</a>
                                <span class="text-align-start">{{item.payment_expiry_date | date:'dd.m.Y' }}</span>
                            </div>
                        </div>
                       
                    </div>
                
                    <div class="cont-menu d-flex justify-content-center align-items-center">
                        <a class="p-2  cont-item rounded" [routerLink]="['/app/analitic', item?.id]"> 
                            <i class="fi fi-rr-chart-histogram"></i>
                        </a>
                        <a class="p-2  cont-item rounded" [routerLink]="['/app/orders', item?.id]"> 
                            <i class="fi fi-rr-order-history"></i>
                        </a>
                        <a class="p-2  cont-item rounded" [routerLink]="['/app/products', item?.id]">
                            <i class="fi fi-rr-hamburger-soda"></i>
                        </a>
                        <a class="p-2  cont-item rounded" [routerLink]="['/app/setting', item?.id]"> 
                            <i class="fi fi-rr-settings"></i>
                        </a>
                        <a class="p-2  cont-item rounded" (click)="updateSite(item.sub_domain, item.id)"> 
                            <i class="fi fi-rr-refresh"></i>
                        </a>
                    </div>
                    
                </div>
            </div>
            <!-- <button class="btn bnt-primary m-auto" (click)="delete(item.sub_domain, item.id)">წაშლა</button> -->
        </div>
    
    </div>
</div>





   






